
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/datasets",
      function () {
        return require("private-next-pages/datasets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/datasets"])
      });
    }
  